<template>
    <div class="page-root">
        <h2 class="title">向经销商获取底价</h2>
        <div class="hr"></div>
        <!-- 自有经销商 -->
        <div v-if="carInfo.dealer_source && carInfo.dealer_source !== 'carp'" class="seller-self">
            <div class="car-info">
                <car-img-title style="margin-right: 24px;" :carInfo="carInfo || {}" />
                <div class="car-name">
                    <car-img-title :carInfo="carInfo || {}" type="title" />
                    <c-select
                        class=""
                        v-on:onchange="handleSelectd"
                        v-on:sendlog="sendLogParse"
                        @sendubclog="sendUbcLog"
                        :modelList="modelList"
                        :selectIdx="selectIdx"
                        :carInfo="carInfo || {}"
                    >
                    </c-select>
                </div>
            </div>
            <div class="user-info">
                <div class="user-input" v-if="isDealerExist">
                    <p class="left-w">姓名</p>
                    <input
                        v-model="username"
                        class="right-input"
                        placeholder="您的称呼"
                        @focus="sendlogInput('name')"
                    >
                    <span class="tips"
                        v-if="!firstSubmit && !username.trim()"
                    >请输入您的名字</span>
                    <span class="tips"
                        v-if="!firstSubmit && username.trim().length > 12"
                    >输入请小于12个字符</span>
                </div>
                <div class="user-input" v-if="isDealerExist">
                    <p class="left-w">手机号</p>
                    <input
                        v-model="userphone"
                        class="right-input"
                        placeholder="请输入11位手机号"
                        @focus="sendlogInput('phone')"
                    >
                    <span class="tips"
                        v-if="!firstSubmit && !userphone.trim()"
                    >请输入您的手机号</span>
                    <span class="tips"
                        v-if="!firstSubmit && userphone.trim() && errorPhone"
                    >请输入正确的手机号</span>
                </div>
                <div class="user-input">
                    <p class="left-w">购车城市</p>
                    <div class="city">
                        <c-select-city
                            v-on:selectcity="onSelectCity"
                            v-on:sendlog="sendLogParse"
                            @sendubclog="sendUbcLog"
                            :carInfo="carInfo || {}"
                            :selectItem="selectItem || {}"
                        />
                    </div>
                </div>
            </div>
            <div class="ask-price" v-if="isDealerExist">
                <button type="button" @click="askPrice" :class="{'send-status': sendStatus}">
                    <i v-if="sendStatus" class="el-icon-loading" />
                    获取底价
                </button>
                <p>点击获取底价即视为同意<span @click="handleOpenModel">《个人信息保护声明》</span></p>
            </div>
            <div class="sellers-title">
                <p class="sellers-left">经销商</p>
                <p class="sellers-right">
                    <span v-if="!firstSubmit && !dealerSelectLength && requestEnd" class="tips">请至少选择一家经销商</span>
                </p>
            </div>
            <div class="sellers" v-if="dealerList && dealerList.length">
                <div class="sellers-content">
                    <label class="sellers-item"
                        v-for="(item, index) in dealerList"
                        :key="item.dealer_id"
                    >
                        <div class="sellers-check">
                            <input type="checkbox"
                                name="sellerName"
                                v-model="sellerName"
                                :value="index"
                                @click="sendlogSeller(item)"
                            >
                            <i></i>
                        </div>
                        <div class="sellers-info">
                            <div class="sellers-name">
                                <p class="sellers-name-n">
                                    <span v-if="item.dealer_type">{{item.dealer_type | toUpperCase}}</span>
                                    {{item.dealer_s_name}}
                                    <c-tag v-if="item.sales_area">{{item.sales_area}}</c-tag>
                                </p>
                                <p class="sellers-addr">{{item.dealer_address}}</p>
                            </div>
                            <p class="sellers-price">{{item.reference_price}}</p>
                            <!-- <p class="sellers-tel">{{item.site_polymorphism.tel_show}}</p> -->
                        </div>
                    </label>
                </div>
                <div v-if="dealerList && dealerList.length >= 3" class="dealer-tips">如询价未取得有效联系，为了更好地满足您的需求，平台会根据您所选车型，通知最多3家同区域经销商与您联系</div>
            </div>
            <!-- 推荐城市经销商 -->
            <div class="sellers offsite-sellers" v-if="offsiteDealerList && offsiteDealerList.length">
                <div class="sellers-content offsite-sellers-content">
                    <label class="sellers-item"
                        v-for="(item, index) in offsiteDealerList"
                        :key="item.dealer_id"
                    >
                        <div v-if="!index" class="offsite-dealerlist-title">
                            <div class="alert-icon"></div>
                            {{offsiteDealerListTitle}}
                        </div>
                        <div class="sellers-check">
                            <input type="checkbox"
                                name="offsiteSellerName"
                                v-model="offsiteSellerName"
                                :value="index"
                                @click="sendlogSeller(item)"
                            >
                            <i></i>
                        </div>
                        <div class="sellers-info">
                            <div class="sellers-name">
                                <p class="sellers-name-n">
                                    <span v-if="item.dealer_type">{{item.dealer_type | toUpperCase}}</span>
                                    {{item.dealer_s_name}}
                                    <c-tag v-if="item.sales_area">{{item.sales_area}}</c-tag>
                                </p>
                                <div class="sellers-bottom">
                                    <p v-if="item.distance" class="sellers-distance">{{item.distance}}</p>
                                    <p class="sellers-addr">{{item.dealer_address}}</p>
                                </div>
                            </div>
                            <p class="sellers-price">{{item.reference_price}}</p>
                        </div>
                    </label>
                </div>
            </div>
            <div class="no-sellers" v-if="!isDealerExist">
                暂无经销商，敬请期待
            </div>
        </div>
        <div v-else class="seller-other">
            <div class="car-info">
                <car-img-title style="margin-right: 24px;" :carInfo="carInfo || {}" />
                <div class="car-name">
                    <car-img-title :carInfo="carInfo || {}" type="title" />
                    <p class="car-price">厂商指导价：{{carInfo.reference_price}}</p>
                </div>
            </div>
            <div class="user-info">
                <div class="user-input">
                    <p class="left-w">购车城市</p>
                    <div class="city">
                        <c-select-city
                            onSelectcity="onSelectCity"
                            v-on:sendlog="sendLogParse"
                            :carInfo="carInfo || {}"
                            :selectItem="{}"
                        />
                    </div>
                </div>
            </div>
            <div class="sellers" v-if="dealerList && dealerList.length">
                <div class="sellers-content">
                    <label class="sellers-item"
                        v-for="item in dealerList"
                        :key="item.dealer_id"
                    >
                        <div class="sellers-info">
                            <div class="sellers-name">
                                <p class="sellers-name-n">
                                    <span v-if="item.dealer_type">{{item.dealer_type | toUpperCase}}</span>
                                    {{item.dealer_s_name}}
                                    <c-tag v-if="item.sales_area">{{item.sales_area}}</c-tag>
                                </p>
                                <p class="sellers-addr">{{item.dealer_address}}</p>
                            </div>
                            <p class="sellers-tel">{{item.site_polymorphism.tel_show}}</p>
                        </div>
                    </label>
                </div>
            </div>
            <div class="no-sellers" v-else>
                暂无经销商，敬请期待
            </div>
        </div>
        <el-dialog
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            :visible="privacyShow"
            @close="handleOpenModel"
        >
            <c-statement />
        </el-dialog>
        <c-qrcode position="SINGLE"/>
        <c-scroll-top :no-qrcode="true" />
    </div>
</template>

<script>

/**
 * @file
 * @author guozhihao02
 */
import {get} from 'lodash';
import {mapGetters, mapMutations} from 'vuex';
import request from 'http/request';
import URLS from 'http/URLS';
import {getOS} from 'js/Utils';
import {bandSdk, sendLog} from 'js/log';
import {sendUbcLog} from 'js/ubclog';
import citySelector from '@/components/city-selector';
import tag from '@/components/tag';
import select from './select';
import statement from './statement';
import mixinLog from '@/mixin/log.js';
import scrollTop from 'components/scroll-top';
import selecteCity from './select-city';
import imgTitle from './img-title';
import Qrcode from '@/components/qrcode';

export default {
    mixins: [mixinLog],
    props: {
        serid: String
    },
    data() {
        return {
            requestEnd: false,
            sellerName: [],
            carInfo: {},
            dealerList: [],
            modelList: [],
            selectIdx: 0,
            selectItem: {},
            username: '',
            userphone: '',
            firstSubmit: true,
            showCity: false,
            autoName: 0,
            autoPhone: 0,
            userphoneAuto: '', // 记录用户原始填充
            submitType: '',
            privacyShow: false,
            sendStatus: false,
            offsiteDealerListTitle: '',
            offsiteDealerList: [],
            offsiteSellerName: [],
            isDefaultDealer: 0
        };
    },
    filters: {
        toUpperCase(str) {
            if (!str) {
                return '';
            }
            else {
                return (str + '').toUpperCase();
            }
        }
    },
    components: {
        'c-select': select,
        'city-selector': citySelector,
        'c-statement': statement,
        'c-scroll-top': scrollTop,
        'c-select-city': selecteCity,
        'car-img-title': imgTitle,
        'c-tag': tag,
        'c-qrcode': Qrcode
    },
    mounted() {
        this.submitType = get(this.$route.query, 'submitType', '');

        /* eslint-disable fecs-camelcase */
        this.query = {
            'series_id': this.serid,
            'model_id': get(this.$route.query, 'modelId', ''),
            'dealer_id': get(this.$route.query, 'dealerId', ''),
            'fromPage': get(this.$route.query, 'fromPage', '')
        };

        // 兼容低版本路由
        if (get(this.$route.query, 'seriesId', '') && !this.serid) {
            this.query.series_id = get(this.$route.query, 'seriesId', ''); // eslint-disable-line
        }

        /* eslint-enable fecs-camelcase */
        this.init();
    },
    computed: {
        isDealerExist() {
            return ((this.dealerList && this.dealerList.length)
                || (this.offsiteDealerList && this.offsiteDealerList.length));
        },
        dealerSelectLength() {
            let val = 0;
            if (this.sellerName && this.sellerName.length) {
                val += this.sellerName.length;
            }

            if (this.offsiteSellerName && this.offsiteSellerName.length) {
                val += this.offsiteSellerName.length;
            }

            return val;
        },
        errorPhone() {
            // 此语句无实际意义，但请不要删
            // 用于添加computed的依赖
            this.userphoneAuto = this.userphoneAuto;
            return !(
            /^1[3456789]\d{9}$/.test(this.userphone.trim())
            || (this.userphoneAuto
            && this.userphoneAuto === this.userphone.trim())
            );
        },
        ...mapGetters({
                    location: 'location' // eslint-disable-line
        })
    },
    watch: {
        sellerName(val) {
            this.isDefaultDealer = 1;
            if (this.dealerSelectLength > 5) {
                this.$message({
                    iconClass: 'el-icon-warning-outline',
                    message: '您最多选择5家经销商',
                    customClass: 'custom-message'
                });
                this.$nextTick(() => {
                    this.sellerName.splice(this.sellerName.length - 1, 1);
                });
            }

        },
        offsiteSellerName(val) {
            if (this.dealerSelectLength > 5) {
                this.$message({
                    iconClass: 'el-icon-warning-outline',
                    message: '您最多选择5家经销商',
                    customClass: 'custom-message'
                });
                this.$nextTick(() => {
                    this.offsiteSellerName.splice(this.offsiteSellerName.length - 1, 1);
                });
            }

        },
        location() {
            this.getmodeldealer();
        }
    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.getmodeldealer();
                this.getUserInfo();
            });
        },
        ...mapMutations({
                    setLocation: 'SET_LOC' // eslint-disable-line
        }),
        getmodeldealer() {
            this.offsiteSellerName = [];
            this.sellerName = [];
            this.offsiteDealerList = [];
            this.dealerList = [];
            this.requestEnd = false;

            /* eslint-disable fecs-camelcase */
            const params = {
                series_id: this.query.series_id,
                city: this.location.cityName || '',
                geo: this.location.lat && this.location.long
                    ? `${this.location.lat}_${this.location.long}` : 0
            };
            if (this.query.model_id) {
                params.model_id = this.query.model_id.replace(/_car_models_aladdin/, '');
            }

            request(URLS.GETMODELDEALER, params, {
                method: 'get'
            })
                .then(res => {
                    const Result = res.Result;
                    const carInfo = Result;
                    this.carInfo = carInfo;

                    let offsiteDealerList = Result.offsite_dealers || [];
                    let dealerList = Result.dealer_list || [];
                    this.dealerList = dealerList;
                    // 如果是自有经销商的话，发一个日志
                    sendLog('ask_price_getDealer', {
                        dealerType: carInfo.dealer_source || 'carp'
                    });
                    if (Result.model_id) {
                        this.query.model_id = Result.model_id + '_car_models_aladdin';
                    }

                    if (Result.dealer_source !== 'carp') {
                        // 当自有经销商覆盖<3家, 共补满5家经销商
                        if (dealerList.length < 3) {
                            const maxLen = 5;
                            // 设置推荐经销商距离0，0km值为空
                            if (offsiteDealerList && offsiteDealerList.length) {
                                offsiteDealerList.map(item => {
                                    if (item.lbs_dist_ui && typeof item.lbs_dist_ui === 'string') {
                                        item.distance = item.lbs_dist_ui.toLowerCase();
                                    }

                                    if (['0', '0km'].includes(item.distance)) {
                                        item.distance = '';
                                    }

                                    return item;
                                });
                                this.offsiteDealerList = offsiteDealerList.slice(0, maxLen - dealerList.length);
                            }

                            if (!dealerList.length) {
                                //  当自有经销商无数据时，默认勾选前3个推荐城市的经销商
                                if (this.offsiteDealerList && this.offsiteDealerList.length) {
                                    this.offsiteDealerListTitle = `${this.location.cityName || ''}暂无合作经销商，以下城市有售`;
                                    this.offsiteSellerName = [...Array(this.offsiteDealerList.length).keys()].slice(0, 3); // eslint-disable-line
                                }
                            }
                            else {
                                // 当自有经销商有数据时，推荐城市的经销商默认不勾选
                                if (this.offsiteDealerList && this.offsiteDealerList.length) {
                                    this.offsiteDealerListTitle = '以下城市可售，供您询价';
                                    this.offsiteSellerName = [];
                                }
                            }
                        }
                        else {
                            // 自有经销商 > 3， 不显示推荐经销商
                            this.offsiteDealerList = [];
                            this.offsiteSellerName = [];
                        }
                        if (dealerList.length) {
                            if (this.query.dealer_id) {
                                let t = Result.dealer_list.findIndex(val => val.dealer_id === this.query.dealer_id);
                                if (t >= 0) {
                                    this.sellerName = [t];
                                }
                            }
                            else {
                                this.sellerName = [...Array(Result.dealer_list.length).keys()].slice(0, 3);
                            }
                            this.sendUbcLog('selectDealer', {type: 'show'});
                        }

                        // if (this.modelList.length) {
                        //     this.setSelectedItem(this.modelList);
                        //     return;
                        // }
                        if (
                            (dealerList && dealerList.length)
                            || (offsiteDealerList && offsiteDealerList.length)
                        ) {
                            this.sendUbcLog('clue_info', {
                                type: 'show',
                                ext: {
                                    train_name: this.carInfo.series_name,
                                    train_id: this.query.series_id,
                                    type_id: this.selectItem.modelId,
                                    type_name: this.selectItem.modelName,
                                    entrance: this.query.fromPage
                                }
                            });
                        }
                        this.getmodellist();
                    }

                })
                .finally(() => {
                    this.requestEnd = true;
                });

            /* eslint-enable fecs-camelcase */
        },
        getmodellist() {

            request(URLS.GETMODELLIST, {

                /* eslint-disable fecs-camelcase */
                series_id: this.query.series_id,
                sort_type: 'price',
                city: this.location.cityName || ''

                /* eslint-enable fecs-camelcase */
            }, {
                method: 'get'
            })
                .then(res => {
                    const Result = res.Result;
                    const {modelList = []} = Result;
                    this.modelList = modelList;
                    this.setSelectedItem(modelList);
                });
        },
        setSelectedItem(modelList) {
            let selectIdx = -1;
            // 如果用户指定了车型
            if (this.query.model_id) {
                selectIdx = modelList.findIndex(item => item.modelId === this.query.model_id);
            }

            // 如果没有找到车型
            if (selectIdx === -1) {
                selectIdx = 0;
                modelList.forEach((item, index) => {
                    if (parseFloat(item.manufacturerPrice)
                        < parseFloat(modelList[selectIdx].manufacturerPrice)
                    ) {
                        selectIdx = index;
                    }

                });
            }

            this.selectIdx = selectIdx;
            this.selectItem = modelList[selectIdx];
        },
        getUserInfo() {
            bandSdk.clue.getFormInfo().then(res => {
                if (res.telephone) {
                    this.userphone = res.telephone;
                    this.userphoneAuto = res.telephone;
                    this.autoPhone = 1;
                    // 已填充
                    this.sendLogParse('ask_price_auto_fill_phone', {
                        fill: 1
                    });
                }
                else {
                    // 未填充
                    this.sendLogParse('ask_price_auto_fill_phone', {
                        fill: 0
                    });
                }

                if (res.username) {
                    // 已获取姓名
                    this.username = res.username || '百度网友';
                    this.autoName = 1;
                    this.sendLogParse('ask_price_auto_fill_name', {
                        fill: 1
                    });
                }
                else {
                    // 未获取，默认百度网友
                    this.username = '百度网友';
                    this.sendLogParse('ask_price_auto_fill_name', {
                        fill: 0
                    });
                }

            }).catch(e => {
                // 错误处理

                this.username = '百度网友';
                this.sendLogParse('ask_price_auto_fill_name', {
                    fill: 0,
                    error: 'catch'
                });
                this.sendLogParse('ask_price_auto_fill_phone', {
                    fill: 0,
                    error: 'catch'
                });
            });
        },
        onSelectCity() {
            this.sellerName = [];
        },
        askPrice() {
            if (this.sendStatus) {
                return;
            }

            this.firstSubmit = false;
            if (!this.username.trim() // 无名
                || this.username.length > 12 // 名字过长
                || !this.userphone.trim() // 无手机
                || this.errorPhone // 手机号不正确
                || (!this.sellerName.length && !this.offsiteSellerName.length) // 没选供应商 也没选异地经销商
            ) {
                return;
            }

            this.sendStatus = true;
            // 本地经销商
            const dealerListLocation = this.dealerList
                .filter((v, i) => this.sellerName.includes(i));
            // 异地经销商
            const dealerListOffset = this.offsiteDealerList
                .filter((v, i) => this.offsiteSellerName.includes(i));
            const checkedDealList = [
                ...dealerListLocation,
                ...dealerListOffset
            ];
            const merchantsInfo = {};
            dealerListLocation.forEach(val => merchantsInfo[val.dealer_id] = '0_' + val.lbs_dist);
            dealerListOffset.forEach(val => merchantsInfo[val.dealer_id] = '1_' + val.lbs_dist);
            const logData = {
                seriesId: this.query.series_id,
                modelId: this.selectItem.modelId,
                fill: this.autoPhone,
                fillName: this.autoName,
                fromPage: this.query.fromPage
            };

            /* eslint-disable fecs-camelcase */
            const ubclogData = {
                ext: {
                    train_name: this.carInfo.series_name,
                    train_id: this.query.series_id,
                    type_id: this.selectItem.modelId,
                    type_name: this.selectItem.modelName,
                    entrance: this.query.fromPage
                }
            };

            const data = {
                source: 'form',
                username: this.username,
                city: this.location.cityName || '',
                province: this.location.province || '',
                telephone: this.userphone,
                model_name: `${this.carInfo.series_name} ${this.selectItem.modelName}`,
                brand_name: this.carInfo.brand_name,
                series_name: this.carInfo.series_name,
                model_id: this.carInfo.model_id,
                model_name_only: this.selectItem.modelName,
                from_page: this.query.fromPage,
                ext: JSON.parse(sessionStorage.getItem('YOUJIA_SESSION_ASK_PRICE_BTN') || '{}'),
                is_default: this.isDefaultDealer,
                ts: +new Date(),
                operate_sys: getOS(),
                user_city: this.location.cityName,
                user_province: this.location.province,
                merchants_info: merchantsInfo
            };

            try {
                const sa = get(this.$route, 'query.sa', undefined);
                const saCard = {
                    alapc_5271_series: 'PC_brand_card',
                    alapc_4526_series: 'PC_train_card'
                };
                if (
                    document.referrer
                    && !(/youjia\.baidu\.com/.test(document.referrer))
                    && saCard[sa]
                ) {
                    data.from_page = saCard[sa];
                    data.ext = {client: 'PCsearch'};
                }
            } catch (error) {}

            bandSdk.clue.submitForm({
                data,
                pageId: get(checkedDealList, '[0].site_polymorphism.material_id', ''),
                id: checkedDealList.map(v => get(v, 'site_polymorphism.thread_id', ''))
            }).then(res => {
                // 成功跳转提交成功页面
                this.$router.push({
                    name: 'ASK_PRICE_SUCEESS'
                });
                this.sendLogParse('price_submit_clk_suc', logData);
                this.sendStatus = false;
            }).catch(e => {
                this.sendLogParse('price_submit_clk_fail', logData);
                this.sendStatus = false;
                // 错误处理
            });
            this.sendLogParse('ask_price_submit_click', logData);
            this.sendUbcLog('clue_info', ubclogData);
            /* eslint-enable fecs-camelcase */
        },
        handleSelectd(e) {
            if (this.selectIdx !== e) {
                this.selectIdx = e;
                this.selectItem = this.modelList[e];
                this.query.model_id = this.modelList[e].modelId; // eslint-disable-line
                this.getmodeldealer();
            }

        },
        handleOpenModel() {
            this.privacyShow = !this.privacyShow;
            if (this.privacyShow) {
                this.sendLogParse('ask_price_privacy_click');
            }

        },
        sendlogSeller(item) {
            this.sendLogParse('ask_price_dealer_click', {
                seriesId: this.carInfo.series_id,
                modelId: get(this.selectItem, 'modelId'),
                cityName: this.location.cityName,
                dealerId: item.dealer_id
            });
            this.sendUbcLog('selectDealer');
        },
        sendlogInput(type) {
            this.sendLogParse(
                `ask_price_input_${type}_click`,
                {
                    seriesId: this.carInfo.series_id,
                    modelId: get(this.selectItem, 'modelId'),
                    cityName: this.location.cityName
                }
            );
        },
        sendLogParse(key, options = {}) {

            /* eslint-disable fecs-camelcase */
            sendLog(key, {
                submit_type: this.submitType,
                ...options
            });
        },
        sendUbcLog(name, options = {}) {
            /* eslint-disable fecs-camelcase */
            sendUbcLog('11435', 'event', {
                value: name,
                type: options.type || 'clk',
                page: '/view/askPrice',
                ...options,
                ext: {
                    client: 'pc',
                    ...(options.ext || {})
                }
            });
            /* eslint-enable fecs-camelcase */
        }
    }
};
</script>

<style lang="less">
@themeColor: #00cecf;

div[class*="el-dialog__body"] {
    overflow: scroll;
    height: 600px;
}
.custom-message {
    min-width: 0;
    height: 36px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 36px;
    background: #fff;
    .el-message__content {
        color: #000;
    }
    .el-icon-warning-outline {
        margin-right: 8px;
        color: @themeColor;
    }
}
</style>

<style lang="less" scoped>
@themeColor: #00cecf;

.page-root {
    width: 940px;
    min-height: 700px;
    margin: 0 auto;
    padding-bottom: 80px;
    .seller-self {
        // overflow: hidden;
        display: inline-block;
    }
    .title {
        margin-top: 30px;
        font-size: 24px;
        line-height: 24px;
        color: #333;
    }
    .hr {
        margin: 30px 0;
        border-bottom: 1px solid #eee;
    }
    .car-info {
        display: flex;
    }
    .user-info {
        .user-input {
            display: flex;
            margin-top: 16px;

            align-items: center;
            .right-input {
                width: 234px;
                height: 40px;
                padding: 0 12px;
                border: 1px solid #eee;
                font-size: 16px;
                line-height: 40px;
                color: #333;
                border-radius: 3px;
                transition: border .15s linear;
                &.isActive,
                &:focus {
                    border-color: @themeColor;
                }
            }
        }
        .left-w {
            width: 120px;
            height: 40px;
            margin-right: 24px;
            font-size: 16px;
            line-height: 40px;
            text-align: right;
            color: #333;
        }
        .city {
            width: 234px;
        }
    }
    .tips {
        margin-left: 24px;
        font-size: 13px;
        color: #f00;
    }
    .ask-price {
        margin: 24px 0 0 144px;
        button {
            width: 234px;
            height: 42px;
            font-size: 16px;
            line-height: 16px;
            color: #fff;
            border-radius: 3px;
            background: @themeColor;
            transition: background .2s linear;
            &.send-status,
            &:hover {
                background: #739bff;
            }
        }
        p {
            margin-top: 16px;
            font-size: 14px;
            line-height: 14px;
            color: #999;
            span {
                color: @themeColor;
                cursor: pointer;
            }
        }
    }
    .sellers-title {
        display: flex;
        height: 16px;
        margin: 42px 0 18px;
        padding-left: 55px;
        font-size: 16px;
        line-height: 16px;
        color: #999;
        .sellers-right {
            width: 796px;
            span {
                display: inline-block;
            }
        }
        .sellers-left {
            width: 64px;
            margin-right: 24px;
            text-align: right;
        }
    }
    .offsite-sellers {
        margin-top: -1px;
    }
    .sellers {
        float: right;
        width: 884px;
        margin-left: 56px;
        .sellers-content {
            width: 100%;
            .sellers-item {
                display: flex;
                padding: 24px 0 23px;
                border-top: 1px solid #eee;
                &:last-child {
                    border-bottom: 1px solid #eee;
                }
                &:hover {
                    background: #f8f8f8;
                }
            }
            .sellers-check {
                margin-right: 24px;

                flex: 1;
                input {
                    visibility: hidden;
                }
                input + i {
                    position: relative;
                    top: 1px;
                    display: block;
                    float: right;
                    box-sizing: border-box;
                    width: 16px;
                    height: 16px;
                    border: 1px solid #636363;
                    border-radius: 50%;
                }
                input:checked + i {
                    border: none;
                    background: @themeColor;
                    &::before {
                        content: "";
                        position: absolute;
                        top: 4px;
                        left: 6px;
                        width: 4px;
                        height: 7px;
                        border-right: 1px solid #fff;
                        border-bottom: 1px solid #fff;
                        transform: rotate(45deg);
                    }
                }
            }
            .sellers-info {
                display: flex;
                width: 796px;
                font-size: 14px;
                line-height: 14px;
                color: #333;

                align-items: center;
                .sellers-name {
                    // width: 587px;
                    flex: 1;
                }
                .sellers-name-n {
                    margin-bottom: 13px;
                    line-height: 18px;
                    span {
                        display: inline-block;
                        height: 18px;
                        margin-right: 12px;
                        padding: 0 5px;
                        border: 1px solid @themeColor;
                        font-size: 12px;
                        text-align: center;
                        color: @themeColor;
                        border-radius: 2px;
                    }
                }
                .sellers-bottom {
                    display: flex;
                    overflow: hidden;
                    color: #999;
                }
                .sellers-distance {
                    margin-right: 20px;
                }
                .sellers-addr {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: #999;

                    flex: 1;
                }
                .sellers-price {
                    // width: 98px;
                    width: 120px;
                    margin-right: 30px;
                    font-size: 18px;
                    line-height: 18px;
                    text-align: right;
                    color: #ff6f61;
                }
            }
        }
        .offsite-sellers-content .sellers-item:first-child {
            flex-wrap: wrap;
        }
    }
    .seller-other {
        // overflow: hidden;
        display: inline-block;
        .car-name {
            margin-top: 14px;
            .car-price {
                margin-top: 12px;
                font-size: 16px;
                line-height: 16px;
                color: #999;
            }
        }
        .sellers-title {
            margin-left: 88px;
        }
        .sellers-content {
            width: 796px;
            margin-left: 88px;
        }
        .sellers {
            margin-top: 24px;
        }
        .sellers-item {
            .sellers-info {
                .sellers-name {
                    width: 620px;
                    margin-right: 11px;
                }
            }
        }
    }
    .no-sellers {
        width: 796px;
        margin: 24px 0 0 144px;
        padding-top: 24px;
        border-top: 1px solid #eee;
        font-size: 16px;
        line-height: 24px;
    }
}
.dealer-tips {
    margin: 13px 0 0 88px;
    font-size: 14px;
    color: #999;
}
.offsite-dealerlist-title {
    display: flex;
    width: 100%;
    padding: 0 0 20px 48px;
    font-size: 12px;
    line-height: 12px;
    color: #999;

    align-items: center;
    flex-shrink: 0;
}
.alert-icon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
    background: no-repeat center ~"/" contain;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACLklEQVRYCcVXsU7DQAzNAiwwsfAFMMHMyoT4qQ79B9r6RVHVNd27tlu37l1Y+gUI9qIX2ehSNyaJhBLp5Iv9zs/x3fkuWdbyKcvyEsArgHcAawB7EfliY191tL0S29Lt37D5fH4nIhMR+RSRY8tG7IRj/2ZoQKxWqysRGQP4Tkh3AEYi8gLgvizLazb2VUfbzvA6dkxfDTTn1YwcwDZxtCyK4uE82muJBbBMxm9bZyPP8ycABw4G8JHn+bOnaKfhWPpQX/T5GI7ULzfyzWKxuA0HtDDSB4CNBdGYCc6TpV0HXET+AbzNZrMDG/sRVkQukiC2Z9cEF5ylvc2Xk3g6nR7Z2I8CoE0zUU0HuWp4TX212tvOuZGbrDlseKFv/cjv2lToPueiWzaMdWojNukADYpkd0wqCKuWFZkuW82ITTbwOTU5mAVyVhWTpVMVO4cOFEZsMoA6kxUrcmes7TovI4cMFEZsMoA6k1ZTTvk7A1hrBl4cMlAYsckA6kws2/rRawbAU43R3DtkoDBikwHUmfTsIOc+0yP1yEPFIQOFEZsMoM5ELs36128ARVHcOGSgMGKTAdSZyPUbwOBT0HcRdi3FaRpOF2GvbdjlMErJ2T/dhr0K0anTLu+1QtS3FHchTLGuFNPY5zDqOwXuMGIAfY7jPouw8TjWLAx3IWEAg1/JkqkY5lLKAPjw6jzYtVxjsEU5zI+JBcE1MdivmQVByS06yM9pGgT7rJj/8Xv+Axs5ngmKto8hAAAAAElFTkSuQmCC);
}
</style>